import { render, staticRenderFns } from "./user_jl.vue?vue&type=template&id=2a55035e&scoped=true"
import script from "./user_jl.vue?vue&type=script&lang=js"
export * from "./user_jl.vue?vue&type=script&lang=js"
import style0 from "./user_jl.vue?vue&type=style&index=0&id=2a55035e&prod&scoped=true&lang=less"
import style1 from "./user_jl.vue?vue&type=style&index=1&id=2a55035e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a55035e",
  null
  
)

export default component.exports